export const getStyledLink = (theme) => ({
    color: theme.palette.info.main,
    textDecoration: "none",
    cursor: "pointer",
});
export const defaultUnderlineStyle = {
    textDecoration: "underline",
};
